export default "__VITE_ASSET__sF82iqL9__"